import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../utils';
import { BarkerApi, App } from '../interfaces';
import { compareAsc, compareDesc } from 'date-fns';

import { EditEventListingAttributes } from '../events-manager/edit-event-listing';
import { ApiService } from './api-service';

export class EventSearchService {

  private api = ApiService;

  search(search: string, postTypes?: string[]) {

    type result = [any[], any[]];

    return this.api.searchEvent().s(search).postType(postTypes).perPage(10) as Observable<BarkerApi.GenericEvent[]>;

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/services/event-search-service.ts